module.exports = __webpack_public_path__ + "static/media/loader.e46d3467.gif";